import React from 'react';
import { Translate, withLocalize } from "react-localize-redux";
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { chartActions } from '../../../store/charts/chartsStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import ChartTooltipNotesRow from './chartTooltipNotesRow';

import '../relationChart.scss';
import '../relationChartFonts.scss';

class ChartLinkTooltip extends React.Component {
    render() {
        const { linkTooltip } = this.props.charts;

        if (isNullOrUndefined(linkTooltip) || !linkTooltip.show || isNullOrUndefined(linkTooltip.context))
            return null;

        const { data, position, linkData } = linkTooltip.context;

        const hasNotes = data.RelationsData[0].CustomNotes && data.RelationsData[0].CustomNotes.length > 0;
        return (
            <div id="entityLinkPopup" className="entity-link-popup"
                style={{ display: 'block', top: `${position.y}px`, left: `${position.x}px` }}>
                <table style={{ display: 'inline-block', paddingBottom: '3px' }}>
                    <thead>
                        <tr>
                            <th style={{ width: '210px' }}><Translate id='Charts.SubjectListName' /></th>
                            <th style={{ width: '550px' }}><Translate id='Charts.SubjectListIC' /></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style={{ paddingBottom: '15px' }}>
                            <td>{linkData.parent.data.Name}</td>
                            {(linkData.parent.data.EntityType === 'PO' || linkData.parent.data.EntityType === 'FOP') && <td>{linkData.parent.data.IC}</td>}
                            {(linkData.parent.data.EntityType === 'FO') && <td>{linkData.parent.data.DateOfBirthOrCreationDateFormated}</td>}
                        </tr>
                        <tr>
                            <td>{linkData.child.data.Name}</td>
                            {(linkData.child.data.EntityType === 'PO' || linkData.child.data.EntityType === 'FOP') && <td>{linkData.child.data.IC}</td>}
                            {(linkData.child.data.EntityType === 'FO') && <td>{linkData.child.data.DateOfBirthOrCreationDateFormated}</td>}
                        </tr>
                    </tbody>
                </table>
                <table>
                    <thead>
                        <tr>
                            <th style={{ width: '210px' }}><Translate id='Charts.RelationType' /></th>
                            <th style={{ width: '80px' }}><Translate id='Charts.From' /></th>
                            <th style={{ width: '80px' }}><Translate id='Charts.To' /></th>
                            <th style={{ width: '80px' }}><Translate id='Charts.ShareInPercent' /></th>
                            <th style={{ width: '90px' }}><Translate id='Charts.WarningHeaderAmmount' /></th>
                            <th style={{ width: '90px' }}><Translate id='Charts.RelationSource' /></th>
                            <th style={{ width: '110px' }}><Translate id='Charts.SubjectListDirection' /></th>
                            {data.RootGroupId !== 'NRCU' && <th style={{ width: '90px' }}><Translate id='Charts.LinkGuarantee' /></th>}
                        </tr>
                    </thead>
                    <tbody>
                        {data.RelationsData.map(rd => <tr key={rd.RelationID}>
                            <td>{rd.Name}
                                {((rd.RootGroupId === 'NRBO' || rd.RelationType === 'NR0217') && !isNullOrUndefined(rd.Function)) && ' - ' + rd.Function}
                                {data.RootGroupId === 'NRCU' && this.getRelationShortening(rd.RelationShortening)}
                            </td>
                            <td>{rd.StartDateFormated}</td>
                            <td>{rd.EndDateFormated}</td>
                            <td>{rd.SharePct}</td>
                            <td>{rd.Deposit} {rd.Currency}</td>
                            <td>{rd.RelationSource}</td>
                            <td>{(rd.Polarity === -1 || rd.Polarity === 1) && (rd.Polarity === -1 ? <Translate id='Charts.LinkDirectionForward' /> : <Translate id='Charts.LinkDirectionBackward' />)}</td>
                            {data.RootGroupId !== 'NRCU' && <td>{this.guaranteed(rd.Guaranteed)}</td>}
                        </tr>)}
                        {hasNotes && <tr><th>&nbsp;</th></tr>}
                        {hasNotes && <ChartTooltipNotesRow notes={data.RelationsData[0].CustomNotes} colspan={7} />}
                    </tbody>
                </table>
            </div>
        );
    }

    getRelationShortening = (shortening) => {
        if (shortening) return " (" + shortening + ")";
        return "";
    }

    guaranteed = (bindingId) => {
        if (bindingId != null)
            if (bindingId === 0)
                return this.props.translate('Charts.LinkGuaranteeUnsure');
            else if (bindingId === 2)
                return this.props.translate('Charts.LinkGuaranteeLessCertain');
            else
                return this.props.translate('Charts.LinkGuaranteeCertain');
        else return this.props.translate('Charts.LinkGuaranteeCertain');
    }

}

export default withRouter(withLocalize(connect(
    state => ({ charts: state.charts }),
    dispatch => bindActionCreators({ ...chartActions }, dispatch)
)(ChartLinkTooltip)));